import { render, staticRenderFns } from "./TcgaMeta.vue?vue&type=template&id=3f408b1e&scoped=true&"
import script from "./TcgaMeta.vue?vue&type=script&lang=js&"
export * from "./TcgaMeta.vue?vue&type=script&lang=js&"
import style0 from "./TcgaMeta.vue?vue&type=style&index=0&id=3f408b1e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f408b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCardTitle,VCol,VContainer,VDataTable,VRow})
